import React from "react";
import { useIntl } from "react-intl";
import { PeekBox, PeekTooltip, useTheme } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
import { focusRingSx } from "../ranking-widget";
import { WhiskerTooltipContent } from "./WhiskerTooltipContent";
export const WhiskerBar = ({ q1Pct, medianPct, q3Pct }) => {
    const intl = useIntl();
    const theme = useTheme();
    const focusRing = focusRingSx(theme);
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekBox, { sx: {
                position: "absolute",
                left: "-1%",
                width: 0,
                height: "100%",
                top: 0,
                borderLeft: "2px dashed white",
                zIndex: 5,
            } }),
        React.createElement(PeekBox, { sx: { position: "absolute", inset: 0, overflow: "hidden", borderRadius: 2 } },
            React.createElement(PeekBox, { sx: {
                    position: "absolute",
                    height: "100%",
                    top: 0,
                    left: 0,
                    width: `${q1Pct}%`,
                    bgcolor: "transparent",
                    borderRadius: "8px 0 0 8px",
                } }),
            React.createElement(PeekTooltip, { title: React.createElement(WhiskerTooltipContent, { title: intl.formatMessage(messages.tooltipLowerBoxTitle), body: intl.formatMessage(messages.tooltipLowerBox) }), placement: "top" },
                React.createElement(PeekBox, { tabIndex: 0, sx: Object.assign(Object.assign({}, focusRing), { position: "absolute", height: "100%", top: 0, left: `${q1Pct}%`, width: `${medianPct - q1Pct}%`, bgcolor: theme.palette.teal[100] }) })),
            React.createElement(PeekTooltip, { title: React.createElement(WhiskerTooltipContent, { title: intl.formatMessage(messages.tooltipUpperBoxTitle), body: intl.formatMessage(messages.tooltipUpperBox) }), placement: "top" },
                React.createElement(PeekBox, { tabIndex: 0, sx: Object.assign(Object.assign({}, focusRing), { position: "absolute", height: "100%", top: 0, left: `${medianPct}%`, width: `${q3Pct - medianPct}%`, bgcolor: theme.palette.teal[300] }) })),
            React.createElement(PeekBox, { sx: {
                    position: "absolute",
                    height: "100%",
                    top: 0,
                    left: `${q3Pct}%`,
                    width: `${100 - q3Pct}%`,
                    bgcolor: "transparent",
                    borderRadius: "0 8px 8px 0",
                } }),
            React.createElement(PeekTooltip, { title: React.createElement(WhiskerTooltipContent, { title: intl.formatMessage(messages.tooltipMedianTitle), body: intl.formatMessage(messages.tooltipMedian) }), placement: "top" },
                React.createElement(PeekBox, { tabIndex: 0, sx: Object.assign(Object.assign({}, focusRing), { position: "absolute", height: "100%", width: 8, top: 0, left: `${medianPct}%`, transform: "translateX(-50%)", zIndex: 2, display: "flex", justifyContent: "center" }) },
                    React.createElement(PeekBox, { sx: { width: 2, height: "100%", bgcolor: "white" } }))))));
};
export default WhiskerBar;
